import MemProactiveWelcomeImage from "@/assets/images/mem-proactive-redirect.svg";
import {
  MDSButton,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";
import styled from "@emotion/styled";

interface WelcomeToProactiveModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WelcomeToProactiveModal = ({ isOpen, onClose }: WelcomeToProactiveModalProps) => {
  return (
    <MDSModalDialog isOpen={isOpen} handleClose={onClose} fluidWidth>
      <div slot={MDSDialogSlotName.Header} />

      <StyledContent slot={MDSDialogSlotName.Content}>
        <StyledIllustration src={MemProactiveWelcomeImage} alt="" aria-hidden="true" />

        <MDSText variant={MDSTextVariant.HeaderL}>Welcome to Mem Proactive</MDSText>

        <MDSText variant={MDSTextVariant.ParagraphSm}>
          Capture thoughts the moment they strike: talk, type, snap it, share it. And with Mem
          Proactive, you&apos;ll get reminded right when it matters.
        </MDSText>
      </StyledContent>

      <StyledFooter slot={MDSDialogSlotName.Footer}>
        <MDSButton onClick={onClose} variant={MDSButtonVariant.Contrast}>
          Got it
        </MDSButton>
      </StyledFooter>
    </MDSModalDialog>
  );
};

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(366px, 80vw);
  text-align: center;
  margin-top: -${({ theme }) => theme.spacing["10"]};
  gap: ${({ theme }) => theme.spacing["2"]};
`;

const StyledIllustration = styled.img`
  width: 100%;
  height: auto;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing["3"]};
`;
